"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = LinkToRecordList;

var _Box2 = _interopRequireDefault(require("@material-ui/core/Box"));

var _AddRounded2 = _interopRequireDefault(require("@material-ui/icons/AddRounded"));

var _Typography2 = _interopRequireDefault(require("@material-ui/core/Typography"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _Button = _interopRequireDefault(require("./Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

LinkToRecordList.propTypes = {
  value: _propTypes["default"].array,
  onClickLink: _propTypes["default"].func,
  onClickShowAll: _propTypes["default"].func
};

function LinkToRecordList(_ref) {
  var value = _ref.value,
      onClickLink = _ref.onClickLink,
      onClickShowAll = _ref.onClickShowAll;
  var data = Array.isArray(value) ? value : [];
  return /*#__PURE__*/_react["default"].createElement(_Box2["default"], null, /*#__PURE__*/_react["default"].createElement(_Typography2["default"], null, "".concat(data.length, " ").concat(data.length > 1 ? " records" : " record"), data.length > 0 ? /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: onClickShowAll,
    size: "small"
  }, "Show all") : null), /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    mt: 1,
    mb: 1
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    startIcon: /*#__PURE__*/_react["default"].createElement(_AddRounded2["default"], {
      fontSize: "small"
    }),
    onClick: onClickLink,
    variant: "contained",
    size: "small",
    style: {
      padding: "1px 10px"
    }
  }, "Link to a record")));
}